/*
  Zugo - urun sayfasi metin bloklari.

  Icerik yoneticiden geldigi icin uzunlugu ongorulemez: kisa aciklamada
  "Devamini Goster" dugmesi gereksiz, uzun aciklamada sart. Bu yuzden
  dugme sabit degil - metnin gercek yuksekligi olculur, esigi asmiyorsa
  dugme hic gosterilmez.
*/
class ZugoReadMore extends HTMLElement {
  connectedCallback() {
    this.icerik = this.querySelector('[data-icerik]');
    this.dugme = this.querySelector('[data-toggle]');
    if (!this.icerik || !this.dugme) return;

    this.esik = parseInt(this.dataset.esik, 10) || 220;
    this.style.setProperty('--zugo-readmore-esik', `${this.esik}px`);

    this.temizle();
    this.dugme.addEventListener('click', () => this.degistir());

    // Gorseller yuklendikce yukseklik degisir; olcum tekrarlanir.
    this.olc();
    if (window.ResizeObserver) {
      this.gozlemci = new ResizeObserver(() => this.olc());
      this.gozlemci.observe(this.icerik);
    }
  }

  disconnectedCallback() {
    this.gozlemci?.disconnect();
  }

  /* Yonetici arka arkaya bos satir birakmis olabiliyor. CSS bunlari
     gizliyor ama olcume dahil olmasinlar diye DOM'dan da cikarilir. */
  temizle() {
    this.icerik.querySelectorAll('p').forEach((p) => {
      const bos = !p.textContent.trim() && !p.querySelector('img, iframe, video');
      if (bos) p.remove();
    });

    // Ust uste <br> yiginlarini teke dusur
    this.icerik.querySelectorAll('br + br').forEach((br) => br.remove());
  }

  olc() {
    if (this.hasAttribute('data-acik')) return;
    const uzun = this.icerik.scrollHeight > this.esik + 40;
    this.toggleAttribute('data-kisaltilmis', uzun);
    this.dugme.hidden = !uzun;
  }

  degistir() {
    const acik = this.toggleAttribute('data-acik');
    this.toggleAttribute('data-kisaltilmis', !acik);
    this.dugme.querySelector('[data-ac]').hidden = acik;
    this.dugme.querySelector('[data-kapali]').hidden = !acik;

    if (!acik) {
      // Kapatirken blogun basina don, yoksa kullanici metnin ortasinda kalir
      const ust = this.getBoundingClientRect().top + window.scrollY - 140;
      window.scrollTo({ top: ust, behavior: 'smooth' });
    }
  }
}

if (!customElements.get('zugo-readmore')) {
  customElements.define('zugo-readmore', ZugoReadMore);
}

/*
  "Bu Urunu Paylas" satiri (Faruk 2026-08-16).

  Iki dugme JavaScript ister:
    - Baglantiyi kopyala: pano API'si yoksa gizli bir input + execCommand
      ile ayni isi yapar (eski Safari / http baglanti).
    - Daha fazla: telefonun kendi paylasim penceresi. Tarayici
      desteklemiyorsa dugme gizli kalir - Instagram gibi adresle
      calismayan uygulamalara ancak bu pencere ulasabiliyor.
*/
(() => {
  const kur = (kok) => {
    kok.querySelectorAll('[data-zugo-paylas]').forEach((kutu) => {
      if (kutu.dataset.zugoHazir) return;
      kutu.dataset.zugoHazir = '1';

      const bildirim = kutu.querySelector('[data-zugo-bildirim]');
      const duyur = (metin) => {
        if (!bildirim) return;
        bildirim.textContent = metin;
        bildirim.setAttribute('data-gorunur', '');
        clearTimeout(kutu._zamanlayici);
        kutu._zamanlayici = setTimeout(() => bildirim.removeAttribute('data-gorunur'), 2200);
      };

      const kopyala = kutu.querySelector('[data-zugo-kopyala]');
      kopyala?.addEventListener('click', async () => {
        const adres = kopyala.dataset.adres;
        try {
          if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(adres);
          } else {
            const gecici = document.createElement('input');
            gecici.value = adres;
            gecici.setAttribute('readonly', '');
            gecici.style.position = 'fixed';
            gecici.style.opacity = '0';
            document.body.appendChild(gecici);
            gecici.select();
            document.execCommand('copy');
            gecici.remove();
          }
          duyur(kopyala.dataset.kopyalandi);
        } catch (e) {
          // Pano izni yoksa adresi secilebilir birakmak disinda yapilacak yok
        }
      });

      const yerel = kutu.querySelector('[data-zugo-yerel-paylas]');
      if (yerel && navigator.share) {
        yerel.hidden = false;
        yerel.addEventListener('click', () => {
          navigator
            .share({
              title: yerel.dataset.baslik,
              text: yerel.dataset.metin,
              url: yerel.dataset.adres,
            })
            .catch(() => {});
        });
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => kur(document));
  } else {
    kur(document);
  }

  // Varyant degisiminde blok yeniden basiliyor olabilir
  document.addEventListener('shopify:section:load', (e) => kur(e.target));
})();
